import { boot } from 'quasar/wrappers';
import { createI18n } from 'vue-i18n';
import messages from '../i18n'

const i18n = createI18n({
  locale: 'ja',
  fallbackLocale: 'ja',
  messages,
});

export default boot(({ app }) => {
  // Set i18n instance on app
  app.use(i18n);
});

export function useI18n() {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { t, te, d, n, ...globalApi } = i18n.global;

  return {
    t: t.bind(i18n),
    d: d.bind(i18n),
    te: te.bind(i18n),
    n: n.bind(i18n),
    ...globalApi,
  };
}
